/** Global tempo control — sets BPM for tempo-synced effects like delay. */

import { Timer } from "lucide-react";
import { useCallback } from "react";

/** Props for the TempoControl component. */
export type TempoControlProps = {
	readonly value: number;
	readonly onChange: (bpm: number) => void;
};

/** Minimum allowed BPM. */
const MIN_BPM = 20 as const;
/** Maximum allowed BPM. */
const MAX_BPM = 300 as const;

export function TempoControl({ value, onChange }: TempoControlProps) {
	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			onChange(Number(e.target.value));
		},
		[onChange],
	);

	return (
		<div className="control-group tempo-control">
			<span className="control-label">
				<Timer size={14} />
				Tempo
			</span>
			<input
				type="range"
				min={MIN_BPM}
				max={MAX_BPM}
				step={1}
				value={value}
				onChange={handleChange}
				className="tempo-slider"
				aria-label="Tempo BPM"
			/>
			<span className="tempo-value">{value} BPM</span>
		</div>
	);
}
